import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type ChatStartEntryDialogStateType = {
  userTabSearchKeyword: string
  groupTabSearchKeyword: string
}

const initialChatStartEntryDialogState: ChatStartEntryDialogStateType = {
  userTabSearchKeyword: '',
  groupTabSearchKeyword: '',
}

export const chatStartEntryDialogSlice = createSlice({
  name: 'chatStartEntryDialog',
  initialState: initialChatStartEntryDialogState,
  reducers: {
    setUserTabSearchKeyword: (state, action: PayloadAction<string>) => {
      state.userTabSearchKeyword = action.payload
    },
    setGroupTabSearchKeyword: (state, action: PayloadAction<string>) => {
      state.groupTabSearchKeyword = action.payload
    },
  },
})

export const { setUserTabSearchKeyword, setGroupTabSearchKeyword } =
  chatStartEntryDialogSlice.actions
